import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {

    /**
     * Intercepts http requests, catches the errors and throws an error with a string based on the error status.
     * The string returned must be handled and translated by the component itself.
     * @param request 
     * @param next 
     * @returns 
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        /**
         * to avoid breaking other parts of the application, we use this interceptor only for tvm-services for now
         * (it can be extendend to other parts of the application later on) 
         * note : we do not intercept csrf token requests, 
         * an error will be thrown when a call using the token will be called
         */
       
        if (request.url.match(/tmv-services\/security\//) || !request.url.match(/tmv-services\//)) {
            return next.handle(request);
        }

        return next.handle(request)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let statusText: string = 'client-side-error';
                 
                    // no internet connection
                    if (error.status === 0 && error.error instanceof ProgressEvent) {
                        statusText = "no-internet-connection";
                    }
                    // Server side error
                    if (error.status >= 400) {
                        statusText = this._getErrorMessage(error.status.toString()); 
                    }
                    
                    return throwError(statusText);
                })
            )
    }

    /**
     * Mapping error codes to error messages
     * The list is not exhaustive, you can complete it if needed
     * @param errorStatus 
     * @returns 
     */
    private _getErrorMessage(errorStatus: string): string {

        let textResponses = {
            '400': 'bad-request',
            '401': 'unauthorized',
            '403': 'forbidden',
            '404': 'not-found',
            '500': 'internal-server-error',
            '503': 'service-unavailable'
        }

        return textResponses[errorStatus] ? textResponses[errorStatus] : textResponses['500'];
    }
}